import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavParams, PopoverController } from '@ionic/angular';
import { AccountService } from 'src/app/services/account.service';
import { SubjectService } from 'src/app/services/subject.service';

@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.scss'],
})
export class AccountListComponent implements OnInit {
  @Input('userAccounts') userAccounts: any;
  constructor(
    private navParams: NavParams,
    private POC: PopoverController,
    private SS: SubjectService,
    private modalController:ModalController
  ) {
    // this.userAccounts = this.navParams.get('userAccounts');
  }

  ngOnInit() {}

  selectAccount(ua: any) {
    localStorage.setItem('switchAccount','true')
    localStorage.setItem('currentAccount',JSON.stringify(ua))
    this.SS.selectedAccount.next(ua);
    this.modalController.dismiss(ua);
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }
}
